import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { User } from '../models/user.model';
import { AreaModel } from '../models/area.model';
import { EmployeeModel } from '../models/employee.model';
import { SubAreaModel } from '../models/subarea.model';

const base_url = environment.base_url;



@Injectable({
  providedIn: 'root'
})
export class BusquedasService {




  constructor( private http: HttpClient ) { }


get token(): string {
  return localStorage.getItem('token') || '';
}
get headers() {
  return {
    headers: {
     'x-token': this.token
    }
};
}


busquedaGlobal( termino: string ) {

  const url = `${ base_url }/todo/${ termino }`;

  return this.http.get( url, this.headers );



}
buscar(
  tipo: 'users'|'subareas'|'employees'|'areas',
  termino: string
) {

  const url = `${ base_url }/todo/coleccion/${ tipo }/${ termino }`;

  return this.http.get<any[]>( url, this.headers )
                  .pipe(
                    map( (resp: any) => {

                      switch (tipo) {

                        case 'users':

                        return this.transformarUsuarios(resp.resultados);

                        case 'areas':

                        return this.transformarAreas(resp.resultados);

                        case 'subareas':

                          return this.transformarSubAreas(resp.resultados);

                        case 'employees':

                          return this.transformarEmpleados(resp.resultados);



                        default:
                          return [];

                      }





                    })
                  );



}



private transformarUsuarios( resultados: any[]): User[] {

return resultados.map(
   user => new User(
              user.name,
              user.email,
             '',
              user.img,
              user.google,
              user.role,
              user.uid,
          )

      );

}

private transformarAreas( resultados: any[]): AreaModel[] {

  return resultados;

  }

private transformarSubAreas( resultados: any[]): SubAreaModel[] {

  return resultados;

  }
private transformarEmpleados( resultados: any[]): EmployeeModel[] {

  return resultados;

  }





}
